import CloseIcon from "@mui/icons-material/Close";
import { Button } from "@mui/material";
import React from "react";
import {
  BootstrapDialog,
  CloseIconButton,
  StyledDialogActions,
  StyledDialogContent,
  StyledDialogTitle
} from "./CustomDialog.styles";
import { CustomDialogProps } from "./CustomDialog.types";
import { SlideTransition } from "./transitions";

export const CustomDialog: React.FC<CustomDialogProps> = ({
  actions,
  actionsSx,
  children,
  closeIconSx,
  contentSx,
  dialogSx,
  disableBackdropClick = false,
  disableEscapeKeyDown = false,
  dividers = true,
  fullWidth = true,
  maxWidth = "sm",
  onClose,
  open,
  paperProps,
  showCloseIcon = true,
  title,
  titleSx
}) => {
  const [internalOpen, setInternalOpen] = React.useState(false);

  // Use internal state if open prop is not controlled
  const isOpen = open ?? internalOpen;

  const handleClose = () => {
    onClose?.();
    setInternalOpen(false);
  };

  const handleDialogClose = (event: unknown, reason: "backdropClick" | "escapeKeyDown") => {
    if (disableBackdropClick && reason === "backdropClick") return;
    if (disableEscapeKeyDown && reason === "escapeKeyDown") return;
    handleClose();
  };

  const defaultActions = (
    <Button autoFocus onClick={handleClose} variant="contained" color="primary" sx={{ minWidth: 80 }}>
      Close
    </Button>
  );

  return (
    <React.Fragment>
      <BootstrapDialog
        onClose={handleDialogClose}
        aria-labelledby="customized-dialog-title"
        open={isOpen}
        maxWidth={maxWidth}
        fullWidth={fullWidth}
        sx={dialogSx}
        PaperProps={paperProps}
        TransitionComponent={SlideTransition}
      >
        <StyledDialogTitle
          sx={{
            ...titleSx,
            paddingRight: showCloseIcon ? 6 : 2
          }}
          id="customized-dialog-title"
        >
          {title}
          {showCloseIcon && (
            <CloseIconButton aria-label="close" onClick={handleClose} sx={closeIconSx}>
              <CloseIcon />
            </CloseIconButton>
          )}
        </StyledDialogTitle>
        <StyledDialogContent dividers={dividers} sx={contentSx}>
          {children}
        </StyledDialogContent>
        <StyledDialogActions sx={actionsSx}>{actions || defaultActions}</StyledDialogActions>
      </BootstrapDialog>
    </React.Fragment>
  );
};

export default CustomDialog;
